import React from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

const componentVisibilityConfig = {
    165: {
        hideConversionRate: true,
        hideCostPerConversion: true,
        hideTotal: true,
    },
    61: {
        hideConversionRate: true,
        hideCostPerConversion: true,
        hideTotal: true,
    },
    94: {
        hideConversionRate: true,
        hideCostPerConversion: true,
        hideTotal: true,
    },
    104: {
        hideConversionRate: true,
        hideCostPerConversion: true,
        hideTotal: true,
    },
    105: {
        hideConversionRate: true,
        hideCostPerConversion: true,
        hideTotal: true,
    },
    110: {
        hideConversionRate: true,
        hideCostPerConversion: true,
        hideTotal: true,
    },
    118: {
        hideConversionRate: true,
        hideCostPerConversion: true,
        hideTotal: true,
    },
    default: {
        hideConversionRate: false,
        hideCostPerConversion: false,
        hideTotal: true,
    },
};

const WebMetricsInfo = () => {
    const { dtcData, totalPaidMediaCPC } = useSelector(
        (state) => state.webMatrix,
    );
    const { company } = useSelector((state) => state.company);
    const {
        isWebMatrixPatientLoading,
        totalImpressions,
        totalClick,
        totalCTR,
        totalConversion,
        totalCostPerConversion,
        totalCost,
    } = dtcData;

    const config =
        componentVisibilityConfig[company.id] ||
        componentVisibilityConfig.default;

    const gridItems = [
        {
            label: 'Impressions',
            value: totalImpressions,
            visible: true,
        },
        {
            label: 'Clicks',
            value: totalClick,
            visible: true,
        },
        {
            label: 'CTR',
            value: `${totalCTR}%`,
            visible: true,
        },
        {
            label: 'Conversion Rate',
            value: `${totalConversion}%`,
            visible: !config.hideConversionRate,
        },
        {
            label: 'Cost Per Conversion',
            value: `$${totalCostPerConversion}`,
            visible: !config.hideCostPerConversion,
        },
        {
            label: 'Total CPC',
            value: `$${totalPaidMediaCPC}`,
            visible: !config.hideTotal,
        },
    ].filter((item) => item.visible);

    const xsValue = 12 / gridItems.length;

    return (
        <Grid container className="flex-row-space-between" spacing={1} xs={12}>
            {isWebMatrixPatientLoading
                ? Array.from({ length: gridItems.length }).map((_, index) => (
                      <Grid item key={index} xs={xsValue}>
                          <Box className="padding-16px bg-gray-50 br-16px">
                              <Box className="flex-row-space-between-center gap-8">
                                  <Skeleton
                                      height={18}
                                      variant="text"
                                      width={140}
                                  />
                              </Box>
                              <Box>
                                  <Skeleton
                                      height={32}
                                      variant="text"
                                      width={50}
                                  />
                              </Box>
                          </Box>
                      </Grid>
                  ))
                : gridItems.map((item, index) => (
                      <Grid item key={index} xs={xsValue}>
                          <Box className="padding-16px bg-gray-50 br-16px">
                              <Box className="flex-row-space-between-center gap-8">
                                  <Typography className="text-400fw-14fs-20lh-bg-gray-500">
                                      {item.label}
                                  </Typography>
                              </Box>
                              <Box>
                                  <Typography className="display-sm-semi-bold gray-900 text-center mt-1">
                                      {item.value}
                                  </Typography>
                              </Box>
                          </Box>
                      </Grid>
                  ))}
        </Grid>
    );
};

export default WebMetricsInfo;
